/* eslint-disable max-len */
// Node Module Imports
import React from 'react'

import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import styled from 'styled-components'

// COmponent IMports
import bls from '../../../../utils/bls-citations'
import Footnote from '../../../elements/Footnote'

// Other imports

const TallLady = ({ className }) => (
  <div className={className}>
    <div className="container py-8">
      <div className="row">
        <div className="col-12 col-md-3">
          <StaticImage src="../../../../assets/images/campus/online-campus-tall-lady.jpg" alt="" />
        </div>
        <div className="col-12 col-md-9">
          <div className="h2 blue">How long does it take to complete an online degree in allied healthcare?</div>
          <p>
            How long it takes to complete an associate degree in one of UMA’s online allied healthcare programs depends
            on the student. However, each associate degree program at UMA will take at least 18 months to complete.
            <Footnote content={'{{"shortcode": "footnote", "content": "${footnoteLanguage.programLength}"}}'} />
          </p>
          <div className="h2 blue">What will my tuition cover?</div>
          <p>
            At UMA, tuition covers more than just your courses. It also includes books, software, and student services
            like one-on-one academic support, job search assistance, interview coaching, and more.
            <Footnote content={'{{"shortcode": "footnote", "content": "${footnoteLanguage.activeDuty}"}}'} /> We also
            have Student Finance advisors who can help you understand financial aid options if you qualify.
          </p>
          <p>
            To learn more about tuition at Ultimate Medical Academy, head to our{' '}
            <Link to="/future-students/tuition">Tuition</Link> page.
          </p>
          <div className="h2 blue">Is Ultimate Medical Academy accredited?</div>
          <p>
            UMA is institutionally accredited by the Accrediting Bureau of Health Education Schools (ABHES.org). The
            U.S. Secretary of Education recognizes ABHES as a national accrediting agency for the accreditation of
            private, postsecondary institutions in the United States offering predominantly allied health education
            programs.
          </p>
          <div className="h2 blue">Why is allied healthcare a good career choice?</div>
          <p>
            When choosing a career path, it's important to consider the factors that could determine your future in the
            field. For starters, is it a meaningful career and is it a growing industry?
          </p>
          <p>
            Well, healthcare and our health systems save lives. Patients require proper patient care from compassionate
            people and the competent processing of medical information is vital to keeping the healthcare system
            running. As people get older, their healthcare needs often increase. These are key factors in why the
            healthcare industry is projected to grow at a much faster rate than all other occupations and is projecting
            to add about {bls.healthcare.growthJobs.number} new jobs between {bls.global.fromDate} and{' '}
            {bls.global.toDate}
            .
            <Footnote
              content={
                '{{"shortcode": "footnote", "content": "${bls.healthcare.growthJobs.sourcePrefix}", "link": "${bls.healthcare.growthJobs.source}"}}'
              }
            />
          </p>
        </div>
      </div>
    </div>
  </div>
)

export default styled(TallLady)``

// TODO: Vertical spacing.
